import { useCallback } from 'react';

export const useUrlNavigation = () => {
  const updateURL = useCallback((insightId: string): void => {
    const url = new URL(window.location.href);
    url.searchParams.set('insight', insightId);
    window.history.pushState({}, '', url.toString());
  }, []);

  const clearURL = useCallback((): void => {
    const url = new URL(window.location.href);
    url.searchParams.delete('insight');
    window.history.pushState({}, '', url.toString());
  }, []);

  const getCurrentInsightURL = useCallback((): string => {
    return window.location.href;
  }, []);

  const getInsightIdFromURL = useCallback((): string | null => {
    const url = new URL(window.location.href);
    return url.searchParams.get('insight');
  }, []);

  return {
    updateURL,
    clearURL,
    getCurrentInsightURL,
    getInsightIdFromURL,
  };
};
